export default __webpack_public_path__ + "static/media/fact_sheet40.760bed31.png";